import { assert_array_not_empty } from '@shared/asserts/utils_asserts';

export class UTILS__array {
  static are_both_empty<T>(array_a: T[], array_b: T[]): boolean {
    return array_a.is_empty() && array_b.is_empty();
  }

  static has_intersection<T>(array_a: T[], array_b: T[]): boolean {
    const set = new Set(array_a);

    let out = array_b.some(item => set.has(item));

    return out;
  }

  static completely_includes<T>(array_bigger: T[], array_smaller: T[]): boolean {
    const set = new Set(array_bigger);

    let out = array_smaller.every(item => set.has(item));

    return out;
  }

  static delete_value<T>(array: T[], value: T): T[] {
    const index = array.indexOf(value);

    if (index == -1) return [];

    let out = array.splice(index, 1);

    return out;
  }
}

export function delete_value_from_array<T>(array: T[], value: T): T[] {
  const index = array.indexOf(value);

  if (index == -1) return [];

  let out = array.splice(index, 1);

  return out;
}

export function getRandomItems<T>(array: T[]): T[] {
  if (!array.length) return [];

  const count = 1 + Math.floor(Math.random() * array.length);
  return [...array].sort(() => Math.random() - 0.5).slice(0, count);
}

export function shuffle_array<T>(array: T[]): T[] {
  const out = [...array]; // Create a shallow copy to avoid mutating the original array

  for (let i = out.length - 1; i > 0; i--) {
    const randomIndex = Math.floor(Math.random() * (i + 1));
    [out[i], out[randomIndex]] = [out[randomIndex], out[i]];
  }

  return out;
}

export function get_random_value<T>(array: T[]): T {
  assert_array_not_empty(array);

  const index_random = Math.floor(Math.random() * array.length);

  return array[index_random];
}

// Helper to chunk an array into smaller arrays of size N
export function chunk_array<T>(array: T[], size: number): T[][] {
  const out: T[][] = [];

  for (let i = 0; i < array.length; i += size) {
    out.push(array.slice(i, i + size));
  }
  return out.reverse();
}

export function is_array_of<T>(target: any, class_object: new (...args: any[]) => T): target is T[] {
  return Array.isArray(target) && target.every(item => item instanceof class_object);
}
